module.exports = __webpack_public_path__ + "img/Expo_TopicA3.9a0e3361.png";